// extracted by mini-css-extract-plugin
export var wrapper = "cookies-popup-module--wrapper--3dOU1";